module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "box-header title-boreder"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('h3', {
    staticClass: "box-title box-title-sub"
  }, [_vm._v(_vm._s(this.title) + " ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relative",
      "top": "-10px !important"
    }
  }, [_c('table', {
    staticClass: "table-summary",
    staticStyle: {
      "padding": "10px !important"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("SKU " + _vm._s(this.unit) + " Cuadradas")]), _vm._v(" "), _c('th', [_vm._v("SKU " + _vm._s(this.unit) + " Inventariadas")]), _vm._v(" "), _c('th', [_vm._v("% " + _vm._s(this.title))])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm._f("formatAmount")(this.totalSkuSquare)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatAmount")(this.totalSkuInventory)))]), _vm._v(" "), _c('td', {
    style: (_vm.formatAmountColor(this.totalEriPercentage))
  }, [_vm._v(_vm._s(this.totalEriPercentage) + "%")])])])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "table-scroll",
    attrs: {
      "id": this.id
    }
  }, [_c('div', {
    staticClass: "table-wrap"
  }, [_c('table', {
    staticClass: "main-table"
  }, [_c('thead', [_c('tr', [_vm._m(0), _vm._v(" "), _vm._l((this.formattedData), function(item) {
    return _c('th', {
      key: 'header_' + item.date,
      staticClass: "header"
    }, [_vm._v("\n                  " + _vm._s(item.date) + "\n                ")])
  })], 2)]), _vm._v(" "), _c('tbody', [_c('tr', [_c('th', {
    staticClass: "fixed-side"
  }, [_vm._v("\n                  SKU " + _vm._s(this.unit) + " \n                  "), _c('br'), _vm._v("\n                  Cuadradas\n                ")]), _vm._v(" "), _vm._l((this.formattedData), function(item) {
    return _c('td', {
      key: 'skuSquare_' + item.date,
      staticClass: "td-value"
    }, [_vm._v("\n                  " + _vm._s(_vm._f("formatAmount")(item.skuSquare)) + "\n                ")])
  })], 2), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "fixed-side"
  }, [_vm._v("\n                  SKU " + _vm._s(this.unit) + " \n                  "), _c('br'), _vm._v("\n                  Inventariadas\n                ")]), _vm._v(" "), _vm._l((this.formattedData), function(item) {
    return _c('td', {
      key: 'skuInventory_' + item.date,
      staticClass: "td-value"
    }, [_vm._v("\n                  " + _vm._s(_vm._f("formatAmount")(item.skuInventory)) + "\n                ")])
  })], 2), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "fixed-side"
  }, [_vm._v("\n                  %\n                  "), _c('br'), _vm._v("\n                  " + _vm._s(this.title) + " \n                ")]), _vm._v(" "), _vm._l((this.formattedData), function(item) {
    return _c('td', {
      key: 'percentage_' + item.date,
      staticClass: "td-value"
    }, [_c('b', [_vm._v(_vm._s(_vm._f("formatDecimal")((((item.skuSquare * 100) / item.skuInventory) || 0))) + "%")])])
  })], 2)])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "fixed-side",
    attrs: {
      "scope": "col"
    }
  }, [_c('div', {
    staticClass: "sideHeader"
  }, [_vm._v("\n                     \n                  ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1cb6bbc8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/inventory/EriDetail.vue
// module id = 502
// module chunks = 1